import "./NlpSideBarStatusLabels.css";
import React, { useState } from "react";

const statuses = ["הכל", "פעיל", "מעוניינ/ת", "בהקפאה", "בשל/ה"];

const NlpSideBarStatusLabels: React.FC = () => {
    const [selected, setSelected] = useState("הכל");

    return (
        <div className="NlpSideBarStatusLabels">
            {statuses.map((status) => (
                <button
                    key={status}
                    className={`status-button ${selected === status ? "selected" : ""}`}
                    onClick={() => setSelected(status)}
                >
                    {status}
                </button>
            ))}
        </div>
    );
};

export default NlpSideBarStatusLabels;